var d = Object.freeze, h = Object.defineProperty;
var l = (e, r) => d(h(e, "raw", { value: d(r || e.slice()) }));
import { L as $ } from "./lds-element-4P-EWHZh.js";
import { i as x, r as c, x as f } from "./lit-element-CwWchyls.js";
import { n as u } from "./property-EvzlnPW3.js";
const y = ["primary", "secondary", "success", "error", "warning", "info"];
var m;
const k = x(m || (m = l(["\n    :host {\n        display: inline-block;\n    }\n\n    .tag {\n        font-size: 12px;\n        padding: 4px 8px;\n        display: flex;\n        align-items: center;\n        border-radius: 2px;\n    }\n\n    .tag.removable {\n        overflow: hidden;\n    }\n\n    .removable .content {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .icon {\n        margin-left: 8px;\n        cursor: pointer;\n    }\n\n    ", "\n\n    .default {\n        background: var(--lds-color-default-0);\n        color: var(--lds-color-default-80);\n        font-weight: normal;\n        border: 1px solid var(--lds-color-default-20);\n    }\n"])), c(
  y.map(
    (e) => c("\n            .".concat(e, " {\n                background-color: var(--lds-color-").concat(e, ");\n                color: var(--lds-color-default-0);\n                border-color: var(--lds-color-").concat(e, ");\n            }\n\n            .").concat(e, ":hover:not(:disabled) {\n                background-color: var(--lds-color-").concat(e, "-dark);\n                border-color: var(--lds-color-").concat(e, "-dark);\n            }\n        "))
  ).join("\n")
));
var w = Object.defineProperty, b = (e, r, n, R) => {
  for (var s = void 0, t = e.length - 1, i; t >= 0; t--)
    (i = e[t]) && (s = i(r, n, s) || s);
  return s && w(r, n, s), s;
}, p, v;
const a = class a extends $ {
  constructor() {
    super(...arguments), this.variant = "default", this.removable = !1;
  }
  onRemoveClick(r) {
    this.emit("remove", { originalEvent: r });
  }
  render() {
    return f(v || (v = l(['\n            <div part="base" class="tag ', " ", '">\n                <span class="content">\n                    <slot part="content"></slot>\n                </span>\n                ', "\n            </div>\n        "])), this.variant, this.removable ? "removable" : "", this.removable ? f(p || (p = l(['<lds-icon class="icon" name="cross-thin" @click=', "></lds-icon>"])), this.onRemoveClick) : "");
  }
};
a.styles = k;
let o = a;
b([
  u({ reflect: !0 })
], o.prototype, "variant");
b([
  u({ type: Boolean })
], o.prototype, "removable");
const g = new URL(import.meta.url), E = g.searchParams.has("debug");
if (!g.searchParams.has("no-define")) {
  const e = customElements.get("lds-tag");
  e ? e.VERSION !== o.VERSION && E && console.log("%clds-tag tried loading in version ".concat(o.VERSION, ", but lds-tag is already defined as ").concat(e.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-tag", o);
}
export {
  o as LdsTag
};
